import React, { Fragment } from 'react';
import Head from 'next/head';
import { AMP_SKIMLINKS_CODE } from 'constants/vendor';

// prettier-ignore
const EXCLUDED_DOMAINS = 'thekitchn.com apartmenttherapy.com amazon.com amazon.ca amazon.cn amazon.de amazon.es amazon.fr amazon.it amazon.co.uk amazon.co.jp amazon.com.br amazon.to amzn.com amzn.ca amzn.cn amzn.de amzn.es amzn.fr amzn.it amzn.co.uk amzn.co.jp amzn.com.br amzn.to'

function AmpSkimLinks() {
  if (!AMP_SKIMLINKS_CODE) {
    return null;
  }
  return (
    <Fragment>
      <Head>
        <script
          async
          custom-element="amp-skimlinks"
          key="amp-skimlinks"
          src="https://cdn.ampproject.org/v0/amp-skimlinks-0.1.js"
        />
      </Head>
      <amp-skimlinks
        layout="nodisplay"
        publisher-code={AMP_SKIMLINKS_CODE}
        excluded-domains={EXCLUDED_DOMAINS}
      />
    </Fragment>
  );
}

export default AmpSkimLinks;
